// extracted by mini-css-extract-plugin
module.exports = {"ContentList":"ContentList_ContentList__8dvVG","Link":"ContentList_Link__td03x"};